import React from 'react';
import { Card, CardContent } from './ui/card';
import * as Icons from 'lucide-react';
import { benefitsData } from './mockData';
import { useLanguage } from '../contexts/LanguageContext';
import { tr } from '../utils/i18n';

const BenefitsSection = () => {
  const { currentLanguage } = useLanguage();
  const l = (text) => tr(currentLanguage, text);

  return (
    <section id="benefits" className="py-20 bg-gradient-to-br from-gray-50 to-blue-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            {l('Pourquoi choisir')}
            <span className="block bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent mt-2">
              {l('OptimHub ?')}
            </span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {l("Découvrez les avantages uniques qui font d'OptimHub la plateforme DSP de référence pour les annonceurs les plus exigeants.")}
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefitsData.map((benefit, index) => {
            const IconComponent = Icons[benefit.icon];

            return (
              <Card
                key={index}
                data-testid={`benefit-card-${index}`}
                className="group hover:shadow-xl transition-all duration-500 hover:-translate-y-1 border-0 bg-white/80 backdrop-blur-sm overflow-hidden"
              >
                <CardContent className="p-8">
                  {/* Icon */}
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-cyan-100 rounded-2xl flex items-center justify-center mb-6 group-hover:from-blue-500 group-hover:to-cyan-500 transition-all duration-300">
                    <IconComponent className="w-8 h-8 text-blue-600 group-hover:text-white transition-colors duration-300" />
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors duration-300">
                    {l(benefit.title)}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {l(benefit.description)}
                  </p>

                  {/* Hover effect indicator */}
                  <div className="mt-6 flex items-center text-blue-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <span className="text-sm font-medium">{l('En savoir plus')}</span>
                    <Icons.ArrowRight className="ml-2 w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-300" />
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-blue-600 to-cyan-500 rounded-3xl p-12 text-white">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              {l('Prêt à transformer vos campagnes publicitaires ?')}
            </h3>
            <p className="text-lg text-blue-100 mb-8 max-w-2xl mx-auto">
              {l('Rejoignez plus de 500 entreprises qui utilisent OptimHub pour maximiser leur ROI publicitaire et atteindre leurs objectifs de croissance.')}
            </p>
            <button
              data-testid="benefits-cta-button"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-white text-blue-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
            >
              {l('Commencer maintenant')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
